export const changeKeys = (dat: any) => {
  return dat.map(
    (curr: {
      [x: string]: any;

      offline_pod_severity: any;
      coverage_severity: any;
    }) => {
      const { offline_pod_severity, coverage_severity, ...rest } = curr;
      return {
        ...rest,
        pod_offline_severity: offline_pod_severity,
        pod_coverage_severity: coverage_severity,
      };
    },
  );
};
